<template>
  <div
    class="additional-fixed-tabs view-toggle-component"
    :class="additionalFixedTabsClass"
  >
    <div class="additional-fixed-tabs__empty"></div>

    <ul class="additional-fixed-tabs__list">
      <li
        v-for="tab in tabs"
        :key="tab.value"
        class="additional-fixed-tabs__item"
        :class="{ active: currentView === tab.value }"
      >
        <a @click.prevent="switchView(tab.value)" href="#">
          <i :class="tab.icon"></i>
          <span :class="{ 'mobile-hidden': hideLabelOnMobile }">{{ tab.label }}</span>
        </a>
      </li>
    </ul>

    <div class="additional-fixed-tabs__empty"></div>
  </div>
</template>

<script>
export default {
  name: 'ViewToggle',
  props: {
    tabs: {
      type: Array,
      required: true
    },
    currentView: {
      type: String,
      required: true
    },
    additionalFixedTabsClass: {
      type: String,
      default: ''
    },
    hideLabelOnMobile: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    switchView(view) {
      if (view !== this.currentView) {
        this.$emit('view-changed', view);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.view-toggle-component {
  width: auto;
  display: flex;
  align-items: center;
  background-color: white;
  height: auto;
  padding: 0;
  z-index: 21;
  gap: 0 !important;


  .additional-fixed-tabs__empty {
    flex: 1;

    @media (max-width: 900px) {
      flex: 0;
    }
  }

  .additional-fixed-tabs__list {
    display: flex;
    align-items: center;
    border: 1px solid var(--attendee-brand-color);
    border-radius: var(--attendee-card-border-radius);
    height: 32px;
    overflow: visible;
    margin-bottom: 0;
    padding: 0;
    list-style: none;
  }

  .additional-fixed-tabs__item {
    position: relative;
    border-right: 1px solid var(--attendee-brand-color);
    height: 100%;

    &:first-child {
      a {
        border-top-left-radius: calc(var(--attendee-card-border-radius) - 1px);
        border-bottom-left-radius: calc(var(--attendee-card-border-radius) - 1px);
      }
    }

    &:last-child {
      border-right: none;

      a {
        border-top-right-radius: calc(var(--attendee-card-border-radius) - 1px);
        border-bottom-right-radius: calc(var(--attendee-card-border-radius) - 1px);
      }
    }

    &.active {
      a {
        color: white;
        background-color: var(--attendee-brand-color);
      }
    }

    a {
      padding: 0 var(--attendee-gap-lg);
      transition: .3s all;
      white-space: nowrap;
      text-decoration: none;
      line-height: 29px;
      font-weight: 400;
      color: var(--attendee-text-primary-color);
      font-size: 19px;
      display: flex;
      align-items: center;
      gap: 8px;
      height: 100%;
      cursor: pointer;

      @media (max-width: 900px) {
        padding: 0 var(--attendee-gap-md);
        font-size: 17px;
      }

      i {
        font-size: 16px;

        @media (max-width: 900px) {
          font-size: 18px;
        }
      }

      span.mobile-hidden {
        @media (max-width: 900px) {
          display: none;
        }
      }

      &:hover {
        opacity: 0.8;
      }
    }
  }
}
</style>
